export default __webpack_public_path__ + "static/media/rithybondeth.c1591fdc.jpg";